import { useMemo } from 'react';
import baseApi, { TAGS } from '../api/baseApi';

/***************************************** API *****************************************/
const qdeckApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchQDeckUsers: builder.query({
      query: () => ({
        url: 'qdeck/users',
        method: 'GET'
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.QDECK_USERS]
    }),
    updateQDeckUsers: builder.mutation({
      query: (qdeckUsers) => ({
        url: 'qdeck/users',
        method: 'PUT',
        body: { users: qdeckUsers }
      }),
      invalidatesTags: [TAGS.QDECK_USERS]
    }),
    fetchBookkeepers: builder.query({
      query: () => ({
        url: 'qdeck/users/bookkeepers',
        method: 'GET'
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.BOOKKEEPERS]
    })
  })
});

/***************************************** HOOKS *****************************************/
export const { useFetchQDeckUsersQuery, useUpdateQDeckUsersMutation, useFetchBookkeepersQuery } = qdeckApi;

export const useQDeckUserEmailNameMap = () => {
  const { data = [], ...other } = useFetchQDeckUsersQuery(undefined, {
    selectFromResult: ({ data = [], ...other }) => ({
      data,
      ...other
    })
  });

  const qdeckUserEmailNameMap = useMemo(() => {
    return data.reduce((map, user) => ({ ...map, [user.email]: `${user.firstname} ${user.lastname}` }), {
      placeholder: ''
    });
  }, [data]);

  return { qdeckUserEmailNameMap, ...other };
};
